import ActionType from '../actions/types';

const initialState = {
  summary: {
    season: { incomplete: 0, total: 0},
    season_media: { incomplete: 0, total: 0},
    paddock_guest_wristband: { incomplete: 0, total: 0},
    vendor_guest_wristband: { incomplete: 0, total: 0},
    broadcast_guest_wristband: { incomplete: 0, total: 0},
    model: { incomplete: 0, total: 0},
    working_single: { incomplete: 0, total: 0},
    media_single: { incomplete: 0, total: 0},
    guest: { incomplete: 0, total: 0},
    guest_wristband: { incomplete: 0, total: 0},
    hotpit_guest: { incomplete: 0, total: 0},
    season_paddock: { incomplete: 0, total: 0},
  },
  assignedCredentials: [],
  credentialToLoad: {}
};

export default function(state = initialState, action) {
  const {type, summary, assignedCredentials, credentialToLoad} = action;

  switch (type) {
    case ActionType.SET_CREDENTIALS_INFO:
      return {
        ...state,
        summary,
        assignedCredentials,
      };
    case ActionType.LOAD_CREDENTIAL:
      return {
        ...state,
        credentialToLoad,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/credentials.js